export function beforeSave(record) {
  const newRecord = { ...record };
  newRecord.upsAccount = record.upsAccount.id;

  // We only support US addresses as the "from" address for UPS shipments at this time.
  // We don't show a country field on the UPS shipment form and assume the address is one from the US (we ask for "state" and "zip")
  // Force country to "US" to persist to correct value and overwrite any incorrect data from source shipments.
  newRecord.toAddress.address.country = "US";
  newRecord.fromAddress.address.country = "US";

  return newRecord;
}
